import React, { useState } from 'react'
import Input from '../../../CustomUi/input'
import {
  faArrowDown,
  faArrowUp,
  faCheck,
  faCopy,
  faEdit,
  faEquals,
  faPlus,
  faVialCircleCheck,
  faWheatAwn,
} from '@fortawesome/free-solid-svg-icons'
import { Box } from '../../../CustomUi/box'
import { Select } from '../../../CustomUi/Select'
import ButtonCustom from '../../../ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeaderTable } from '../../../CustomUi/table/headerTable'
import { BodyTable } from '../../../CustomUi/table/bodyTable'
import { Render } from '../../../CustomUi/render'
import { RowTable } from '../../../CustomUi/table/rowTable'
import { RowItem } from '../../../CustomUi/table/rowItem'
import { DeleteButton } from '../../../CustomUi/deleteButton'
import { Empty } from 'antd'

interface PropsFormDoses {
  doseMax: string
  setDoseMax: React.Dispatch<React.SetStateAction<string>>
  doseMin: string
  setDoseMin: React.Dispatch<React.SetStateAction<string>>
  dosePadrao: string
  setDosePadrao: React.Dispatch<React.SetStateAction<string>>
  cultura: string
  setCultura: React.Dispatch<React.SetStateAction<string>>
  culturaId: number
  setCulturaId: React.Dispatch<React.SetStateAction<number>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number | string>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  dosagens: {
    cod?: number | string
    cultura_nome: string
    cod_cultura: number
    dose: string | number
    min_dose: string | number
    max_dose: string | number
  }[]
  dataCultura: any[]
  editar: boolean
  cod_dose: number
  inserirDosesCultura: Function
  editarDoses: Function
  deletarDoses: Function
}

export const FormDoses: React.FC<PropsFormDoses> = ({
  doseMax,
  setDoseMax,
  doseMin,
  setDoseMin,
  dosePadrao,
  setDosePadrao,
  cultura,
  setCultura,
  culturaId,
  setCulturaId,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  dosagens,
  dataCultura,
  editar,
  cod_dose,
  inserirDosesCultura,
  editarDoses,
  deletarDoses,
}) => {
  const [openCultura, setOpenCultura] = useState<boolean>(false)

  function mascaraDecimal(data, elemento) {
    let area = data.replace(/\D/g, '')
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')

    if (elemento === 'dmax') {
      setDoseMax(area)
    }

    if (elemento === 'dmin') {
      setDoseMin(area)
    }

    if (elemento === 'dpa') {
      setDosePadrao(area)
    }
  }

  return (
    <>
      <Box>
        <Select
          label='Cultura'
          placeholder='Selecione a cultura'
          icon={faWheatAwn}
          value={cultura}
          onChange={setCultura}
          onChangeID={setCulturaId}
          open={openCultura}
          trigger={setOpenCultura}
          items={dataCultura}
          descricaoItem={'nome'}
          idItem={'cod'}
          disabled={editar}
        />

        <div className='campo__dois__inputs'>
          <Input
            label='Dose máxima'
            icon={faArrowUp}
            placeholder='Digite a dose máxima'
            value={doseMax}
            onChange={(e) => mascaraDecimal(e, 'dmax')}
          />
          <Input
            label='Dose mínima'
            icon={faArrowDown}
            placeholder='Digite a dose mínima'
            value={doseMin}
            onChange={(e) => mascaraDecimal(e, 'dmin')}
          />
        </div>
        <Input
          label='Dose padrão'
          icon={faEquals}
          placeholder='Digite a dose padrão'
          value={dosePadrao}
          onChange={(e) => mascaraDecimal(e, 'dpa')}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonCustom
            onClick={() => inserirDosesCultura(cod_dose)}
            icon={<FontAwesomeIcon icon={editar ? faCheck : faPlus} />}
          >
            {editar ? 'Atualizar' : 'Inserir'}
          </ButtonCustom>
        </div>
      </Box>
      <div style={{ marginTop: '10px' }}>
        <HeaderTable
          itens={[
            { valor: 'Cultura', width: 'calc(100% - 450px)' },
            { valor: 'Máxima', width: '90px' },
            { valor: 'Mínima', width: '90px' },
            { valor: 'Padrão', width: '90px' },
            { valor: 'Ações', width: '150px' },
          ]}
        />

        <BodyTable
          style={{
            height: 'calc(100% - 100px )',
            position: 'relative',
            overflowX: 'hidden',
            overflowY: 'scroll',
            marginTop: -10,
          }}
        >
          <Render condition={true}>
            {(dosagens ?? []).map(
              ({ cod, cod_cultura, cultura_nome, max_dose, min_dose, dose }) => {
                return (
                  <RowTable key={cod} style={{ height: '80px' }}>
                    <RowItem
                      fontSize={12}
                      style={{ alignItems: 'center' }}
                      width={'calc(100% - 444.5px)'}
                    >
                      {cultura_nome}
                    </RowItem>

                    <RowItem
                      fontSize={12}
                      width={'90px'}
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        alignContent: 'center',
                      }}
                    >
                      {max_dose}
                    </RowItem>
                    <RowItem
                      fontSize={12}
                      width={'90px'}
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        alignContent: 'center',
                      }}
                    >
                      {min_dose}
                    </RowItem>
                    <RowItem
                      fontSize={12}
                      width={'90px'}
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        alignContent: 'center',
                      }}
                    >
                      {dose}
                    </RowItem>

                    <RowItem width={'180px'} gap={10}>
                      <DeleteButton
                        open={confirmar_exclusao && id_item_atual === cod}
                        trigger={setConfirmar_exclusao}
                        onTrigger={() => {
                          setId_item_atual(cod)
                          setNome_item_atual(cultura_nome)
                        }}
                        loading={fake_loading}
                        message={`o item ${cultura_nome} será excluido!`}
                        deleteds={[cultura_nome]}
                        onDelete={() => deletarDoses(cod)}
                        disabled={fake_loading}
                        typeButtonTrigger='tertiary'
                      />
                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={faCopy} />}
                        onClick={() =>
                          editarDoses(
                            cod,
                            cultura_nome,
                            cod_cultura,
                            max_dose,
                            min_dose,
                            dose,
                            'duplicar'
                          )
                        }
                        type='secondary'
                      />
                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={faEdit} />}
                        onClick={() =>
                          editarDoses(
                            cod,
                            cultura_nome,
                            cod_cultura,
                            max_dose,
                            min_dose,
                            dose,
                            'editar'
                          )
                        }
                      />
                    </RowItem>
                  </RowTable>
                )
              }
            )}
          </Render>

          <Render condition={dosagens.length <= 0}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum alvo cadastrado!</>}
            />
          </Render>
        </BodyTable>
      </div>
    </>
  )
}
